(function(d,w) {
  var currentURLParam = new URLSearchParams(window.location.search);
  let paramFound = currentURLParam.has("product-type-breadcrumbs");
  
  if (paramFound) {
    fetch(window.Shopify.routes.root + "?section_id=async-internal-tool-breadcrumb-mo-lookup")
      .then(res => res.text())
      .then(txt => {
        var parsedDOM = new DOMParser().parseFromString(txt, "text/html");
        
        var sectionDOM = parsedDOM.querySelector(".shopify-section");
        var sectionBody = sectionDOM.querySelector(".product-type-match-with-metaobject");
        var toggleBtn = sectionBody.querySelector('[data-product-type-match-with-metaobject-btn]');
        
        if (sectionBody && toggleBtn) {
          toggleBtn.addEventListener('click', () => {
            sectionBody.classList.toggle("hide-types-with-match");
          })
        }
        
        document.body.prepend(sectionDOM);
        
        window.scrollTo({ top: 0, behaviour: "smooth" });
      });
  }
})(document, window);